import type { FaireProductEntity } from "../../entity_types/product";

export const p_bqxv84g93d: FaireProductEntity = {
  token: "p_bqxv84g93d",
  type: "product",
  name: "Pave Stud - Snake - Gold Earrings",
  brandToken: "b_f0fbd5c7",
  brandName: "JaxKelly",
  imageUrl:
    "https://cdn.faire.com/fastly/f900a14f2df4253edafe6773bf4171aa203337b986d6ac07c57151c510deb7b5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0a355c4f0f1358d86c83f50c08df8c206c542e70a3069d08fa246189272357bf.jpeg",
    "https://cdn.faire.com/fastly/ec765f9764dd0e239bf5308b791346823fcf9617158ca7225dda399ab6140b46.jpeg",
    "https://cdn.faire.com/fastly/9d936672bfa9342f77808c1b8dc3b92f78c663d33b18cf962016079056316d20.jpeg",
    "https://cdn.faire.com/fastly/80ec88ea204a1da33135f6fa452ecfdd1c782496486931b0167855ece645631f.jpeg",
    "https://cdn.faire.com/fastly/54291f2fd6c30a5b6a6429d28eb9da0a11fd363bd10c15fa7a6fc9796f5a009c.jpeg",
  ],
  priceDollars: 19.1,
  description:
    "• A small snake with white CZ stones.\n• Tarnish Free - Long lasting protective coating safeguarding your jewelry from sweat, water, and more.\n• Sterling Silver Posts – 18K gold plating over brass\n• Hypoallergenic – Lead Free",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:01.520Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
